export type LegalBlock = { type: "title" | "heading" | "paragraph"; text: string };

const content: LegalBlock[] = [
  {
    "type": "title",
    "text": "Vay Có Ngay - Điều khoản và Điều kiện sử dụng"
  },
  {
    "type": "paragraph",
    "text": "COMPUTER GARAGE\n(sau đây gọi là “Vay Có Ngay”, “Công ty”, “Chúng tôi” hoặc “của Chúng tôi”) là chủ sở hữu và đơn vị vận hành ứng dụng di động mang tên Vay Có Ngay (“Ứng dụng”) và website admin.vaycongay.net (“Website”). Ứng dụng và Website được gọi chung là “Nền tảng”."
  },
  {
    "type": "paragraph",
    "text": "Với tư cách là người sử dụng Nền tảng (“Người dùng”), Người dùng hiểu và đồng ý rằng Nền tảng được xây dựng nhằm hỗ trợ kết nối người dùng có nhu cầu tiếp cận các sản phẩm, dịch vụ tài chính với các tổ chức tài chính, đối tác dữ liệu, đối tác cung cấp dịch vụ và các bên liên quan khác."
  },
  {
    "type": "paragraph",
    "text": "Nền tảng có thể hỗ trợ giới thiệu, hiển thị và kết nối Người dùng với các sản phẩm tài chính phù hợp như khoản vay tiêu dùng, bảo hiểm, thẻ tín dụng và các dịch vụ tài chính hợp pháp khác theo quy định của pháp luật Việt Nam."
  },
  {
    "type": "paragraph",
    "text": "Trong Điều khoản này, “Người dùng” được hiểu là cá nhân hoặc tổ chức truy cập, đăng ký, sử dụng hoặc tương tác với Nền tảng, bao gồm khách hàng cá nhân, tổ chức tài chính, đối tác dữ liệu và các đối tác hợp tác khác."
  },
  {
    "type": "paragraph",
    "text": "Bằng việc truy cập, đăng ký hoặc sử dụng Nền tảng, Người dùng xác nhận đã đọc, hiểu và đồng ý tuân thủ các Điều khoản và Điều kiện sử dụng này (“Điều khoản”), cùng các chính sách, thông báo và quy định khác được Vay Có Ngay công bố trên Nền tảng theo từng thời điểm."
  },
  {
    "type": "paragraph",
    "text": "Điều khoản này cùng với Chính sách Bảo mật của Vay Có Ngay tạo thành thỏa thuận pháp lý giữa Người dùng và Vay Có Ngay, quy định việc sử dụng Nền tảng cũng như các sản phẩm, dịch vụ được giới thiệu hoặc cung cấp thông qua Nền tảng."
  },
  {
    "type": "paragraph",
    "text": "Nếu Người dùng không đồng ý với bất kỳ nội dung nào trong Điều khoản này, vui lòng ngừng truy cập và sử dụng Nền tảng."
  },
  {
    "type": "paragraph",
    "text": "Trước khi sử dụng Nền tảng, Người dùng vui lòng đọc kỹ toàn bộ Điều khoản. Việc đăng ký tài khoản hoặc sử dụng bất kỳ chức năng nào của Nền tảng được xem là Người dùng đã chấp thuận đầy đủ các nội dung được quy định tại đây."
  },
  {
    "type": "heading",
    "text": "1. Quy định chung"
  },
  {
    "type": "paragraph",
    "text": "Nền tảng là hệ thống kết nối trực tuyến được xây dựng nhằm hỗ trợ Người dùng tiếp cận các sản phẩm, dịch vụ tài chính từ các tổ chức tài chính, ngân hàng, đối tác dữ liệu và các đối tác cung cấp dịch vụ liên quan."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay chỉ đóng vai trò là đơn vị cung cấp nền tảng công nghệ, hỗ trợ giới thiệu, hiển thị thông tin và kết nối Người dùng với các sản phẩm tài chính phù hợp."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay không phải là tổ chức tín dụng, ngân hàng hoặc công ty tài chính theo quy định pháp luật Việt Nam và không trực tiếp thực hiện hoạt động cho vay, cấp tín dụng, nhận tiền gửi hoặc huy động vốn từ khách hàng."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay không cung cấp khoản vay dưới danh nghĩa của mình và không tham gia vào quá trình xét duyệt, phê duyệt hoặc quyết định cấp tín dụng."
  },
  {
    "type": "paragraph",
    "text": "Mọi quyết định liên quan đến việc cung cấp sản phẩm tài chính, xét duyệt hồ sơ, giải ngân, thu hồi nợ và các điều kiện giao dịch khác thuộc trách nhiệm của các tổ chức tài chính hoặc đối tác cung cấp dịch vụ tương ứng."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay thông qua Nền tảng có thể giới thiệu các sản phẩm, dịch vụ tài chính do đối tác hoặc bên thứ ba cung cấp, đồng thời có thể cung cấp các dịch vụ hỗ trợ phân tích dữ liệu, cung cấp thông tin và các dịch vụ hỗ trợ khác trong phạm vi pháp luật cho phép."
  },
  {
    "type": "paragraph",
    "text": "Người dùng có trách nhiệm tự xem xét, đánh giá và quyết định việc sử dụng các sản phẩm hoặc dịch vụ được giới thiệu trên Nền tảng."
  },
  {
    "type": "heading",
    "text": "2. Điều kiện sử dụng dịch vụ"
  },
  {
    "type": "paragraph",
    "text": "Người dùng sử dụng Nền tảng cam kết và bảo đảm rằng:"
  },
  {
    "type": "paragraph",
    "text": "Là cá nhân từ đủ 18 tuổi trở lên hoặc tổ chức được thành lập và hoạt động hợp pháp theo quy định pháp luật;"
  },
  {
    "type": "paragraph",
    "text": "Có đầy đủ năng lực hành vi dân sự để xác lập và thực hiện các giao dịch theo quy định pháp luật Việt Nam;"
  },
  {
    "type": "paragraph",
    "text": "Có quyền hợp pháp để truy cập và sử dụng các dịch vụ được cung cấp trên Nền tảng theo Điều khoản này."
  },
  {
    "type": "paragraph",
    "text": "Việc đăng ký tài khoản hoặc sử dụng Nền tảng đồng nghĩa với việc Người dùng xác nhận đã đọc, hiểu và đồng ý tuân thủ toàn bộ nội dung của Điều khoản."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay có quyền từ chối, tạm ngừng hoặc chấm dứt quyền sử dụng dịch vụ của Người dùng trong các trường hợp:"
  },
  {
    "type": "paragraph",
    "text": "Người dùng vi phạm Điều khoản và Điều kiện sử dụng;"
  },
  {
    "type": "paragraph",
    "text": "Người dùng cung cấp thông tin không chính xác, không đầy đủ hoặc gây hiểu nhầm;"
  },
  {
    "type": "paragraph",
    "text": "Người dùng có hành vi gian lận, giả mạo hoặc sử dụng Nền tảng cho mục đích trái pháp luật;"
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay có cơ sở hợp lý xác định Người dùng không đáp ứng điều kiện sử dụng dịch vụ theo quy định pháp luật hoặc Điều khoản này."
  },
  {
    "type": "paragraph",
    "text": "Trong phạm vi pháp luật cho phép, Vay Có Ngay có quyền khóa hoặc chấm dứt tài khoản, đồng thời xóa thông tin hoặc nội dung do Người dùng đăng tải trên Nền tảng trong các trường hợp cần thiết."
  },
  {
    "type": "heading",
    "text": "3. Chấp nhận Điều khoản"
  },
  {
    "type": "paragraph",
    "text": "Bằng việc truy cập, đăng ký hoặc sử dụng Nền tảng, Người dùng xác nhận đã đọc, hiểu và đồng ý tuân thủ Điều khoản này cùng các chính sách, quy định, thông báo và tuyên bố khác được Vay Có Ngay công bố trên Nền tảng."
  },
  {
    "type": "paragraph",
    "text": "Người dùng có trách nhiệm đọc kỹ và thường xuyên cập nhật các nội dung được công bố trên Nền tảng."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay có quyền sửa đổi, bổ sung, cập nhật hoặc thay thế một phần hoặc toàn bộ Điều khoản này khi cần thiết nhằm phù hợp với hoạt động kinh doanh hoặc quy định pháp luật hiện hành."
  },
  {
    "type": "paragraph",
    "text": "Các thay đổi sẽ được công bố trên Nền tảng hoặc thông báo bằng phương thức phù hợp."
  },
  {
    "type": "heading",
    "text": "4. Quản lý tài khoản"
  },
  {
    "type": "heading",
    "text": "4.1 Đăng ký tài khoản"
  },
  {
    "type": "paragraph",
    "text": "Để sử dụng một số chức năng trên Nền tảng, Người dùng có thể cần đăng ký tài khoản Vay Có Ngay."
  },
  {
    "type": "paragraph",
    "text": "Khi đăng ký tài khoản, Người dùng cam kết cung cấp thông tin chính xác, đầy đủ và cập nhật theo yêu cầu của Nền tảng."
  },
  {
    "type": "paragraph",
    "text": "Người dùng chịu trách nhiệm bảo đảm tính hợp pháp, chính xác và trung thực của các thông tin đã cung cấp."
  },
  {
    "type": "paragraph",
    "text": "Trong quá trình đăng ký và sử dụng dịch vụ, Vay Có Ngay có thể yêu cầu Người dùng cung cấp một số thông tin cần thiết nhằm:"
  },
  {
    "type": "paragraph",
    "text": "Xác minh danh tính;"
  },
  {
    "type": "paragraph",
    "text": "Đảm bảo an toàn tài khoản;"
  },
  {
    "type": "paragraph",
    "text": "Cung cấp các chức năng phù hợp;"
  },
  {
    "type": "paragraph",
    "text": "Tuân thủ các yêu cầu pháp luật hiện hành."
  },
  {
    "type": "paragraph",
    "text": "Người dùng không được:"
  },
  {
    "type": "paragraph",
    "text": "Sử dụng thông tin của người khác để đăng ký tài khoản;"
  },
  {
    "type": "paragraph",
    "text": "Tạo nhiều tài khoản nhằm mục đích gian lận hoặc trục lợi;"
  },
  {
    "type": "paragraph",
    "text": "Cung cấp thông tin giả mạo hoặc gây hiểu nhầm;"
  },
  {
    "type": "paragraph",
    "text": "Cho phép người khác sử dụng tài khoản của mình trái phép."
  },
  {
    "type": "heading",
    "text": "4.2 Bảo mật tài khoản"
  },
  {
    "type": "paragraph",
    "text": "Người dùng có trách nhiệm tự bảo vệ thông tin đăng nhập và các thông tin bảo mật liên quan đến tài khoản của mình."
  },
  {
    "type": "paragraph",
    "text": "Người dùng không nên cung cấp mật khẩu, mã xác thực hoặc thông tin bảo mật tài khoản cho bất kỳ bên thứ ba nào."
  },
  {
    "type": "paragraph",
    "text": "Trong trường hợp phát hiện hoặc nghi ngờ tài khoản bị truy cập trái phép, Người dùng cần thông báo ngay cho Vay Có Ngay để được hỗ trợ xử lý."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay sẽ áp dụng các biện pháp kỹ thuật và quản lý phù hợp nhằm bảo vệ an toàn tài khoản của Người dùng."
  },
  {
    "type": "paragraph",
    "text": "Tuy nhiên, Người dùng hiểu rằng việc bảo mật tài khoản cũng phụ thuộc vào việc sử dụng và quản lý thông tin cá nhân của chính Người dùng."
  },
  {
    "type": "heading",
    "text": "4.3 Tạm khóa và chấm dứt tài khoản"
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay có quyền tạm ngừng, hạn chế hoặc chấm dứt quyền sử dụng tài khoản của Người dùng trong các trường hợp:"
  },
  {
    "type": "paragraph",
    "text": "Người dùng vi phạm Điều khoản này hoặc các quy định liên quan;"
  },
  {
    "type": "paragraph",
    "text": "Người dùng có hành vi gian lận, giả mạo hoặc gây ảnh hưởng đến hoạt động của Nền tảng;"
  },
  {
    "type": "paragraph",
    "text": "Người dùng sử dụng Nền tảng cho mục đích trái pháp luật;"
  },
  {
    "type": "paragraph",
    "text": "Có yêu cầu từ cơ quan nhà nước có thẩm quyền;"
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay có cơ sở hợp lý xác định việc tiếp tục cung cấp dịch vụ có thể gây rủi ro cho Người dùng, đối tác hoặc hệ thống."
  },
  {
    "type": "paragraph",
    "text": "Trong trường hợp tài khoản bị tạm khóa hoặc chấm dứt, Vay Có Ngay sẽ thông báo cho Người dùng bằng phương thức phù hợp khi cần thiết."
  },
  {
    "type": "heading",
    "text": "5. Bảo vệ dữ liệu cá nhân và quyền riêng tư"
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay tôn trọng quyền riêng tư của Người dùng và cam kết bảo vệ dữ liệu cá nhân theo quy định pháp luật Việt Nam hiện hành."
  },
  {
    "type": "paragraph",
    "text": "Việc thu thập, sử dụng, lưu trữ, chia sẻ và bảo vệ dữ liệu cá nhân của Người dùng được thực hiện theo Chính sách quyền riêng tư của Vay Có Ngay."
  },
  {
    "type": "paragraph",
    "text": "Bằng việc sử dụng Nền tảng, Người dùng xác nhận đã đọc, hiểu và đồng ý với việc Vay Có Ngay xử lý dữ liệu cá nhân trong phạm vi cần thiết để:"
  },
  {
    "type": "paragraph",
    "text": "Cung cấp và duy trì dịch vụ;"
  },
  {
    "type": "paragraph",
    "text": "Xác minh danh tính;"
  },
  {
    "type": "paragraph",
    "text": "Cải thiện trải nghiệm sử dụng;"
  },
  {
    "type": "paragraph",
    "text": "Đảm bảo an toàn hệ thống;"
  },
  {
    "type": "paragraph",
    "text": "Phòng ngừa gian lận và các hành vi vi phạm;"
  },
  {
    "type": "paragraph",
    "text": "Tuân thủ nghĩa vụ pháp lý."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay chỉ thu thập những dữ liệu cần thiết, phù hợp với mục đích sử dụng dịch vụ."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay áp dụng các biện pháp bảo mật phù hợp nhằm hạn chế nguy cơ mất mát, truy cập trái phép, tiết lộ hoặc sử dụng sai mục đích dữ liệu cá nhân."
  },
  {
    "type": "paragraph",
    "text": "Người dùng có quyền thực hiện các quyền liên quan đến dữ liệu cá nhân theo quy định pháp luật, bao gồm:"
  },
  {
    "type": "paragraph",
    "text": "Quyền truy cập dữ liệu;"
  },
  {
    "type": "paragraph",
    "text": "Quyền chỉnh sửa, cập nhật thông tin;"
  },
  {
    "type": "paragraph",
    "text": "Quyền yêu cầu xóa dữ liệu trong phạm vi pháp luật cho phép;"
  },
  {
    "type": "paragraph",
    "text": "Quyền rút lại sự đồng ý;"
  },
  {
    "type": "paragraph",
    "text": "Các quyền hợp pháp khác theo quy định hiện hành."
  },
  {
    "type": "paragraph",
    "text": "Chi tiết về việc xử lý dữ liệu cá nhân được quy định tại Chính sách quyền riêng tư của Vay Có Ngay."
  },
  {
    "type": "heading",
    "text": "6. Quyền truy cập và giấy phép sử dụng"
  },
  {
    "type": "heading",
    "text": "6.1 Quyền sử dụng Nền tảng"
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay cấp cho Người dùng quyền truy cập và sử dụng Nền tảng trong phạm vi được cho phép theo Điều khoản này."
  },
  {
    "type": "paragraph",
    "text": "Quyền sử dụng này chỉ nhằm mục đích cá nhân hoặc mục đích hợp pháp liên quan đến việc sử dụng các sản phẩm, dịch vụ được cung cấp trên Nền tảng."
  },
  {
    "type": "paragraph",
    "text": "Người dùng không được:"
  },
  {
    "type": "paragraph",
    "text": "Sao chép, sửa đổi, phân phối hoặc khai thác trái phép bất kỳ nội dung nào trên Nền tảng;"
  },
  {
    "type": "paragraph",
    "text": "Can thiệp, phá hoại hoặc gây ảnh hưởng đến hoạt động bình thường của hệ thống;"
  },
  {
    "type": "paragraph",
    "text": "Sử dụng công nghệ hoặc phương thức tự động nhằm thu thập dữ liệu trái phép từ Nền tảng;"
  },
  {
    "type": "paragraph",
    "text": "Sử dụng thương hiệu, logo, nội dung hoặc tài sản trí tuệ của Vay Có Ngay khi chưa có sự cho phép bằng văn bản."
  },
  {
    "type": "heading",
    "text": "6.2 Quyền sở hữu trí tuệ"
  },
  {
    "type": "paragraph",
    "text": "Toàn bộ nội dung, thiết kế, giao diện, biểu tượng, logo, phần mềm, mã nguồn, dữ liệu và các tài sản trí tuệ khác trên Nền tảng thuộc quyền sở hữu hoặc quyền sử dụng hợp pháp của Vay Có Ngay hoặc các bên cấp phép liên quan."
  },
  {
    "type": "paragraph",
    "text": "Việc Người dùng truy cập hoặc sử dụng Nền tảng không đồng nghĩa với việc chuyển giao bất kỳ quyền sở hữu trí tuệ nào."
  },
  {
    "type": "paragraph",
    "text": "Mọi hành vi sao chép, sử dụng, khai thác hoặc phân phối tài sản trí tuệ của Vay Có Ngay khi chưa được cho phép có thể bị xem là hành vi vi phạm pháp luật."
  },
  {
    "type": "heading",
    "text": "7. Giám sát nền tảng và tài khoản"
  },
  {
    "type": "paragraph",
    "text": "Nhằm đảm bảo an toàn, ổn định và tuân thủ quy định pháp luật, Vay Có Ngay có quyền giám sát hoạt động sử dụng Nền tảng của Người dùng trong phạm vi cần thiết."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay có thể áp dụng các biện pháp kỹ thuật nhằm:"
  },
  {
    "type": "paragraph",
    "text": "Phát hiện và ngăn chặn hành vi gian lận;"
  },
  {
    "type": "paragraph",
    "text": "Bảo vệ hệ thống khỏi các hành vi tấn công hoặc truy cập trái phép;"
  },
  {
    "type": "paragraph",
    "text": "Đảm bảo Người dùng sử dụng Nền tảng đúng mục đích;"
  },
  {
    "type": "paragraph",
    "text": "Tuân thủ yêu cầu từ cơ quan quản lý có thẩm quyền."
  },
  {
    "type": "paragraph",
    "text": "Trong trường hợp phát hiện hành vi bất thường hoặc vi phạm Điều khoản, Vay Có Ngay có quyền:"
  },
  {
    "type": "paragraph",
    "text": "Yêu cầu Người dùng cung cấp thêm thông tin xác minh;"
  },
  {
    "type": "paragraph",
    "text": "Hạn chế một số chức năng tài khoản;"
  },
  {
    "type": "paragraph",
    "text": "Tạm ngừng hoặc chấm dứt quyền truy cập;"
  },
  {
    "type": "paragraph",
    "text": "Thực hiện các biện pháp cần thiết khác theo quy định pháp luật."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay cam kết thực hiện việc giám sát một cách hợp lý, phù hợp với mục đích bảo vệ an toàn hệ thống và quyền lợi hợp pháp của Người dùng."
  },
  {
    "type": "paragraph",
    "text": "Phiên bản cập nhật sẽ có hiệu lực kể từ thời điểm được công bố, trừ khi có quy định khác."
  },
  {
    "type": "paragraph",
    "text": "Việc Người dùng tiếp tục truy cập hoặc sử dụng Nền tảng sau khi Điều khoản được cập nhật đồng nghĩa với việc Người dùng đồng ý với các nội dung sửa đổi."
  },
  {
    "type": "heading",
    "text": "8. Các hành vi bị nghiêm cấm"
  },
  {
    "type": "paragraph",
    "text": "Khi sử dụng Nền tảng, Người dùng cam kết không thực hiện các hành vi sau đây:"
  },
  {
    "type": "paragraph",
    "text": "Sử dụng Nền tảng cho các mục đích vi phạm pháp luật Việt Nam hoặc quy định của cơ quan có thẩm quyền;"
  },
  {
    "type": "paragraph",
    "text": "Cung cấp thông tin giả mạo, sai lệch, không đầy đủ hoặc sử dụng thông tin của người khác khi chưa được cho phép;"
  },
  {
    "type": "paragraph",
    "text": "Giả mạo danh tính của cá nhân, tổ chức hoặc sử dụng tài khoản của người khác;"
  },
  {
    "type": "paragraph",
    "text": "Sử dụng Nền tảng để thực hiện hành vi gian lận, lừa đảo, rửa tiền hoặc các hành vi bất hợp pháp khác;"
  },
  {
    "type": "paragraph",
    "text": "Can thiệp, phá hoại, gây gián đoạn hoặc ảnh hưởng đến hoạt động bình thường của Nền tảng;"
  },
  {
    "type": "paragraph",
    "text": "Cố gắng truy cập trái phép vào hệ thống, máy chủ, dữ liệu hoặc tài khoản của Người dùng khác;"
  },
  {
    "type": "paragraph",
    "text": "Sử dụng công cụ tự động, phần mềm hoặc phương thức kỹ thuật nhằm thu thập dữ liệu, sao chép nội dung hoặc khai thác trái phép Nền tảng;"
  },
  {
    "type": "paragraph",
    "text": "Phát tán mã độc, virus hoặc các chương trình có khả năng gây ảnh hưởng đến hệ thống;"
  },
  {
    "type": "paragraph",
    "text": "Xâm phạm quyền sở hữu trí tuệ, quyền riêng tư hoặc các quyền hợp pháp khác của Vay Có Ngay, Người dùng hoặc bên thứ ba;"
  },
  {
    "type": "paragraph",
    "text": "Sử dụng thông tin, nội dung hoặc dịch vụ trên Nền tảng cho mục đích thương mại trái phép."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay có quyền áp dụng các biện pháp phù hợp trong trường hợp phát hiện Người dùng có hành vi vi phạm, bao gồm nhưng không giới hạn:"
  },
  {
    "type": "paragraph",
    "text": "Hạn chế quyền truy cập;"
  },
  {
    "type": "paragraph",
    "text": "Tạm khóa hoặc chấm dứt tài khoản;"
  },
  {
    "type": "paragraph",
    "text": "Xóa nội dung vi phạm;"
  },
  {
    "type": "paragraph",
    "text": "Yêu cầu Người dùng chịu trách nhiệm đối với các thiệt hại phát sinh;"
  },
  {
    "type": "paragraph",
    "text": "Phối hợp với cơ quan có thẩm quyền khi cần thiết."
  },
  {
    "type": "heading",
    "text": "9. Tuyên bố miễn trừ trách nhiệm"
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay nỗ lực cung cấp Nền tảng ổn định, an toàn và chính xác nhằm hỗ trợ Người dùng tiếp cận các sản phẩm, dịch vụ tài chính phù hợp."
  },
  {
    "type": "paragraph",
    "text": "Tuy nhiên, Người dùng hiểu và đồng ý rằng:"
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay chỉ cung cấp nền tảng công nghệ và dịch vụ hỗ trợ kết nối thông tin;"
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay không phải là bên cho vay, tổ chức tín dụng hoặc bên quyết định việc cấp khoản vay;"
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay không đảm bảo rằng mọi yêu cầu vay hoặc đăng ký dịch vụ tài chính của Người dùng sẽ được chấp thuận;"
  },
  {
    "type": "paragraph",
    "text": "Việc xét duyệt, phê duyệt, giải ngân, điều kiện giao dịch và các quyết định liên quan thuộc trách nhiệm của tổ chức tài chính hoặc đối tác cung cấp dịch vụ tương ứng."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay không chịu trách nhiệm đối với:"
  },
  {
    "type": "paragraph",
    "text": "Quyết định phê duyệt hoặc từ chối khoản vay của tổ chức tài chính;"
  },
  {
    "type": "paragraph",
    "text": "Điều kiện, lãi suất, phí hoặc các nghĩa vụ phát sinh giữa Người dùng và bên cung cấp dịch vụ tài chính;"
  },
  {
    "type": "paragraph",
    "text": "Việc thực hiện nghĩa vụ của các bên tham gia giao dịch tài chính;"
  },
  {
    "type": "paragraph",
    "text": "Thiệt hại phát sinh do Người dùng cung cấp thông tin không chính xác, không đầy đủ hoặc không cập nhật;"
  },
  {
    "type": "paragraph",
    "text": "Các sự cố ngoài khả năng kiểm soát hợp lý của Vay Có Ngay."
  },
  {
    "type": "paragraph",
    "text": "Người dùng có trách nhiệm tự đánh giá và quyết định trước khi sử dụng bất kỳ sản phẩm hoặc dịch vụ nào được giới thiệu trên Nền tảng."
  },
  {
    "type": "heading",
    "text": "10. Giới hạn trách nhiệm"
  },
  {
    "type": "paragraph",
    "text": "Trong phạm vi pháp luật cho phép, Vay Có Ngay không chịu trách nhiệm đối với các thiệt hại trực tiếp hoặc gián tiếp phát sinh từ:"
  },
  {
    "type": "paragraph",
    "text": "Việc Người dùng sử dụng hoặc không thể sử dụng Nền tảng;"
  },
  {
    "type": "paragraph",
    "text": "Các quyết định tài chính được đưa ra dựa trên thông tin hiển thị trên Nền tảng;"
  },
  {
    "type": "paragraph",
    "text": "Hành vi, lỗi hoặc vi phạm của các tổ chức tài chính, đối tác hoặc bên thứ ba;"
  },
  {
    "type": "paragraph",
    "text": "Việc Người dùng không tuân thủ Điều khoản này;"
  },
  {
    "type": "paragraph",
    "text": "Sự cố kỹ thuật, gián đoạn hệ thống, lỗi mạng hoặc các nguyên nhân nằm ngoài khả năng kiểm soát hợp lý của Vay Có Ngay."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay cam kết áp dụng các biện pháp hợp lý nhằm duy trì hoạt động ổn định của Nền tảng."
  },
  {
    "type": "paragraph",
    "text": "Tuy nhiên, Người dùng hiểu rằng không có hệ thống công nghệ nào có thể đảm bảo hoạt động liên tục, hoàn toàn không xảy ra lỗi hoặc rủi ro."
  },
  {
    "type": "heading",
    "text": "11. Bồi thường thiệt hại"
  },
  {
    "type": "paragraph",
    "text": "Người dùng đồng ý chịu trách nhiệm và bồi thường cho Vay Có Ngay, các công ty liên kết, đối tác, nhân viên hoặc bên đại diện hợp pháp của Vay Có Ngay đối với các thiệt hại, chi phí hoặc trách nhiệm phát sinh do:"
  },
  {
    "type": "paragraph",
    "text": "Người dùng vi phạm Điều khoản này;"
  },
  {
    "type": "paragraph",
    "text": "Người dùng sử dụng Nền tảng cho mục đích trái pháp luật;"
  },
  {
    "type": "paragraph",
    "text": "Người dùng cung cấp thông tin sai lệch, giả mạo hoặc gây thiệt hại cho bên khác;"
  },
  {
    "type": "paragraph",
    "text": "Người dùng xâm phạm quyền, lợi ích hợp pháp của Vay Có Ngay hoặc bên thứ ba."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay có quyền yêu cầu Người dùng khắc phục vi phạm, chịu trách nhiệm đối với thiệt hại phát sinh và thực hiện các nghĩa vụ liên quan theo quy định pháp luật."
  },
  {
    "type": "heading",
    "text": "12. Liên kết với bên thứ ba"
  },
  {
    "type": "paragraph",
    "text": "Nền tảng có thể chứa các liên kết hoặc nội dung được cung cấp bởi bên thứ ba nhằm hỗ trợ Người dùng tiếp cận thêm thông tin hoặc dịch vụ liên quan."
  },
  {
    "type": "paragraph",
    "text": "Các liên kết này chỉ nhằm mục đích thuận tiện cho Người dùng."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay không kiểm soát và không chịu trách nhiệm đối với:"
  },
  {
    "type": "paragraph",
    "text": "Nội dung, sản phẩm hoặc dịch vụ do bên thứ ba cung cấp;"
  },
  {
    "type": "paragraph",
    "text": "Tính chính xác, đầy đủ hoặc cập nhật của thông tin trên website hoặc nền tảng bên thứ ba;"
  },
  {
    "type": "paragraph",
    "text": "Các giao dịch, thỏa thuận hoặc tranh chấp phát sinh giữa Người dùng và bên thứ ba."
  },
  {
    "type": "paragraph",
    "text": "Người dùng nên tự xem xét các điều khoản, chính sách bảo mật và thông tin liên quan của bên thứ ba trước khi sử dụng dịch vụ."
  },
  {
    "type": "heading",
    "text": "13. Xác nhận của Người dùng"
  },
  {
    "type": "paragraph",
    "text": "Bằng việc truy cập và sử dụng Nền tảng, Người dùng xác nhận rằng:"
  },
  {
    "type": "paragraph",
    "text": "Đã đọc, hiểu và đồng ý với toàn bộ nội dung của Điều khoản này;"
  },
  {
    "type": "paragraph",
    "text": "Cam kết cung cấp thông tin chính xác, hợp pháp và đầy đủ;"
  },
  {
    "type": "paragraph",
    "text": "Hiểu rõ vai trò của Vay Có Ngay là đơn vị cung cấp nền tảng công nghệ và dịch vụ hỗ trợ kết nối;"
  },
  {
    "type": "paragraph",
    "text": "Hiểu rằng các quyết định liên quan đến sản phẩm tài chính thuộc về tổ chức tài chính hoặc đối tác cung cấp dịch vụ tương ứng;"
  },
  {
    "type": "paragraph",
    "text": "Đồng ý tuân thủ các quy định, chính sách và hướng dẫn được Vay Có Ngay công bố trên Nền tảng."
  },
  {
    "type": "paragraph",
    "text": "Nếu Người dùng không đồng ý với bất kỳ nội dung nào trong Điều khoản này, Người dùng cần ngừng sử dụng Nền tảng."
  },
  {
    "type": "heading",
    "text": "14. Giải quyết tranh chấp"
  },
  {
    "type": "paragraph",
    "text": "Điều khoản này được điều chỉnh và giải thích theo quy định của pháp luật Việt Nam."
  },
  {
    "type": "paragraph",
    "text": "Trong quá trình sử dụng Nền tảng, nếu phát sinh bất kỳ vấn đề, khiếu nại hoặc tranh chấp nào giữa Người dùng và Vay Có Ngay, hai bên sẽ ưu tiên giải quyết thông qua việc trao đổi, thương lượng trên tinh thần hợp tác và thiện chí."
  },
  {
    "type": "paragraph",
    "text": "Người dùng có thể gửi yêu cầu hỗ trợ hoặc khiếu nại thông qua các phương thức liên hệ được Vay Có Ngay công bố trên Nền tảng."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay sẽ tiếp nhận, xem xét và phản hồi các yêu cầu của Người dùng trong thời gian hợp lý theo quy định và quy trình xử lý nội bộ."
  },
  {
    "type": "paragraph",
    "text": "Trong trường hợp các bên không thể đạt được thỏa thuận thông qua thương lượng, tranh chấp sẽ được giải quyết tại cơ quan có thẩm quyền của Việt Nam theo quy định pháp luật hiện hành."
  },
  {
    "type": "paragraph",
    "text": "Người dùng và Vay Có Ngay cam kết phối hợp cung cấp thông tin, tài liệu cần thiết nhằm hỗ trợ quá trình giải quyết tranh chấp một cách minh bạch và phù hợp."
  },
  {
    "type": "heading",
    "text": "15. Chính sách hoàn tiền"
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay không trực tiếp cung cấp khoản vay, không thu xếp khoản vay và không trực tiếp tham gia vào các giao dịch tài chính giữa Người dùng và tổ chức tài chính hoặc đối tác cung cấp dịch vụ."
  },
  {
    "type": "paragraph",
    "text": "Do đó, việc hoàn tiền, điều chỉnh khoản thanh toán hoặc xử lý các khoản phí liên quan đến sản phẩm tài chính sẽ được thực hiện theo chính sách và thỏa thuận giữa Người dùng với tổ chức tài chính hoặc bên cung cấp dịch vụ tương ứng."
  },
  {
    "type": "paragraph",
    "text": "Trong trường hợp Người dùng sử dụng các dịch vụ khác do Vay Có Ngay trực tiếp cung cấp (nếu có), chính sách hoàn tiền sẽ được áp dụng theo thông báo, điều khoản dịch vụ hoặc thỏa thuận liên quan được Vay Có Ngay công bố tại từng thời điểm."
  },
  {
    "type": "paragraph",
    "text": "Người dùng có trách nhiệm kiểm tra kỹ các điều khoản, chi phí và nghĩa vụ liên quan trước khi xác nhận sử dụng bất kỳ sản phẩm hoặc dịch vụ nào trên Nền tảng."
  },
  {
    "type": "heading",
    "text": "16. Thông tin liên hệ"
  },
  {
    "type": "paragraph",
    "text": "Nếu Người dùng có bất kỳ câu hỏi, yêu cầu hỗ trợ, phản hồi hoặc khiếu nại nào liên quan đến việc sử dụng Nền tảng hoặc Điều khoản này, vui lòng liên hệ với Vay Có Ngay thông qua:"
  },
  {
    "type": "paragraph",
    "text": "Đơn vị vận hành:\nCOMPUTER GARAGE"
  },
  {
    "type": "paragraph",
    "text": "Email:\nservice@vaycongay.net"
  },
  {
    "type": "paragraph",
    "text": "Hotline:\n+84 0382895190"
  },
  {
    "type": "paragraph",
    "text": "Thời gian hỗ trợ:\nThứ Hai – Thứ Bảy, 08:00 – 18:30"
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay cam kết tiếp nhận và hỗ trợ các yêu cầu của Người dùng nhằm đảm bảo trải nghiệm sử dụng Nền tảng được thuận tiện, minh bạch và an toàn."
  },
  {
    "type": "heading",
    "text": "Xác nhận cuối cùng"
  },
  {
    "type": "paragraph",
    "text": "Bằng việc tiếp tục truy cập hoặc sử dụng Nền tảng, Người dùng xác nhận rằng đã đọc, hiểu và đồng ý với toàn bộ nội dung của Điều khoản và Điều kiện sử dụng Vay Có Ngay."
  },
  {
    "type": "paragraph",
    "text": "Người dùng hiểu và đồng ý rằng:"
  },
  {
    "type": "paragraph",
    "text": "Việc sử dụng Nền tảng phải tuân thủ các quy định pháp luật hiện hành;"
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay cung cấp nền tảng công nghệ và dịch vụ hỗ trợ kết nối thông tin;"
  },
  {
    "type": "paragraph",
    "text": "Các sản phẩm tài chính được cung cấp bởi tổ chức tài chính hoặc đối tác liên quan sẽ chịu sự điều chỉnh của các điều khoản và thỏa thuận riêng;"
  },
  {
    "type": "paragraph",
    "text": "Người dùng có trách nhiệm tự đánh giá và quyết định trước khi sử dụng bất kỳ sản phẩm hoặc dịch vụ nào."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay có quyền cập nhật, sửa đổi Điều khoản này nhằm phù hợp với sự thay đổi của pháp luật, hoạt động vận hành hoặc yêu cầu quản lý."
  },
  {
    "type": "paragraph",
    "text": "Phiên bản mới nhất của Điều khoản sẽ được công bố trên Nền tảng và có hiệu lực kể từ thời điểm được đăng tải, trừ khi có quy định khác."
  },
  {
    "type": "paragraph",
    "text": "Vay Có Ngay\nĐiều khoản và Điều kiện sử dụng\nPhiên bản cập nhật: 2026"
  }
];

export default content;
